import { APICore } from './apiCore'

const api = new APICore()

function getCategoryExperiences (params) {
  const baseUrl = '/category-experiences'
  return api.get(baseUrl, params)
}

function getCategoryExperience (id) {
  const baseUrl = `/category-experiences/${id}`
  return api.get(baseUrl, {})
}

function addCategoryExperience (params) {
  const baseUrl = '/category-experiences'
  return api.createWithFile(baseUrl, params)
}

function updateCategoryExperience (params) {
  const baseUrl = '/category-experiences'
  return api.updateWithFile(baseUrl, params)
}

function deleteCategoryExperience (params) {
  const baseUrl = '/category-experiences'
  return api.delete(baseUrl, params)
}

export { getCategoryExperiences, getCategoryExperience, addCategoryExperience, updateCategoryExperience, deleteCategoryExperience }
